import { render, staticRenderFns } from "./Text2.vue?vue&type=template&id=1e8fe2de&scoped=true&"
import script from "./Text2.vue?vue&type=script&lang=js&"
export * from "./Text2.vue?vue&type=script&lang=js&"
import style0 from "./Text2.vue?vue&type=style&index=0&id=1e8fe2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8fe2de",
  null
  
)

export default component.exports